
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { ShieldCheckIcon } from 'lucide-react';

export const DemoModeAlert = () => {
  return (
    <Alert className="bg-green-50 border-green-200">
      <ShieldCheckIcon className="h-4 w-4 text-green-500" />
      <AlertTitle className="text-green-800">Admin Access Only</AlertTitle>
      <AlertDescription className="text-green-700">
        <p className="mb-2">
          This section is restricted to super admin access only. You can view and manage all registered users in the system.
        </p>
        <p>
          User management is protected by Row Level Security (RLS) policies that ensure only authorized administrators can access this data.
        </p>
      </AlertDescription>
    </Alert>
  );
};
